import React, { useEffect, useMemo, useState } from 'react';
import { Button, Split, SplitItem, GalleryItem } from '@patternfly/react-core';
import _ from 'lodash';
// import './Cards.css';
import { useTranslation } from 'localization/useTranslation';
import DescriptionCard, { DescriptionCardSkeleton } from 'components/DescriptionCard/DescriptionCard';
import useAPI from 'services/useAPI';
import { useMutation } from '@tanstack/react-query';
import { EDIT_TYPE } from 'components/DescriptionCard/DescriptionCard';
import { v4 } from 'uuid';

const ProviderClientCard = ({ providerClientInfo, isLoading = false, hasEdit = false, updateProviderClientInfo }) => {
  const api = useAPI();
  const T = useTranslation();
  const [providerClient, setProviderClient] = useState();
  const [key, setKey] = useState(v4());

  const providerClientModels = [
    { label: T.common.dataProvider, path: 'provider.displayName' },
    { label: T.common.id, path: 'id' },
    { label: T.common.displayname, path: 'displayName', key, editType: (hasEdit) ? EDIT_TYPE.inline : undefined },
    { label: T.common.description, path: 'description', key, editType: (hasEdit) ? EDIT_TYPE.textarea : undefined },
    { label: T.common.template, path: 'template.displayName' }
  ];

  useEffect(function updateInternalInfo() {
    setProviderClient(providerClientInfo);
  }, [providerClientInfo]);

  const providerClientMutation = useMutation({
    mutationFn: (updatedProviderClient) => {
      return api.core.updateProviderClient(null, providerClientInfo?.provider?.id, providerClientInfo.id, updatedProviderClient);
    },
    onSuccess: updateProviderClientInfo()
  });

  const cardFooter = useMemo(() => {
    const a1 = _.pick(providerClient, ['displayName', 'description']);
    const a2 = _.pick(providerClientInfo, ['displayName', 'description']);
    if (!_.isEqual(a1, a2)) {
      return (
        <Split hasGutter>
          <SplitItem><Button
            isLoading={providerClientMutation.isPending}
            onClick={() => {
              providerClientMutation.mutate(_.pick(providerClient, ['displayName', 'description']));
            }}>{ T.common.update }</Button>
          </SplitItem>
          <SplitItem><Button onClick={() => {
            setProviderClient({ ...providerClientInfo });
            setKey(v4());
          }}>{ T.common.cancel }</Button>
          </SplitItem>
        </Split>
      );
    }
    return null;
  }, [T.common.cancel, T.common.update, providerClientMutation, providerClient, providerClientInfo]);


  return (
    (providerClientInfo) ?
      <GalleryItem>
        { isLoading && <DescriptionCardSkeleton /> }
        { !isLoading &&
          <DescriptionCard
            models={providerClientModels}
            item={providerClient} setItem={setProviderClient}
            heading={T.common.dataProvider}
            isLoading={isLoading}
            footer={cardFooter}
          />
        }
      </GalleryItem>
      : <></>
  );
};

export default ProviderClientCard;
